var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgStop(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 90,
    viewBox: "0 0 80 90",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.1765 0H11.7647C5.26724 0 0 5.26724 0 11.7647V77.6471C0 84.1445 5.26724 89.4118 11.7647 89.4118H21.1765C27.6739 89.4118 32.9412 84.1445 32.9412 77.6471V11.7647C32.9412 5.26724 27.6739 0 21.1765 0Z",
    fill: "#CACEAC"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M68.2353 0H58.8235C52.3261 0 47.0588 5.26724 47.0588 11.7647V77.6471C47.0588 84.1445 52.3261 89.4118 58.8235 89.4118H68.2353C74.7328 89.4118 80 84.1445 80 77.6471V11.7647C80 5.26724 74.7328 0 68.2353 0Z",
    fill: "#CACEAC"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgStop);
export default __webpack_public_path__ + "static/media/stop.ab3db7a9705690d6f622ad3b7b0f0c93.svg";
export { ForwardRef as ReactComponent };